import React, {useState, useEffect, Fragment} from 'react';
import { ContactDetails, TextHighlight, AddButton, NewDeviceField, CheckIcon, UserIcon, BackButton, VisDiv, Photos, Comments,Loading, ViewLabelValueField, FieldDropdown, ClientDetailsReport} from '../components';
import { useStateContext } from '../context/StateContext';
import { useCreateReplace, useSet, useSetOnlyPassedData } from '../hooks/mutations';
import useNetworkStatus from '../hooks/useNetworkStatus';
import { successAlert, sortByLastName, siteAddress, gMapAddressLink, errorAlert, siteName, gMapLink  } from '../lib/utils';
import { MdGpsFixed } from "react-icons/md";
import {FiMapPin } from 'react-icons/fi'
import TestButton from './frontend_components/TestButton';
import Swal from 'sweetalert2';





/**
 * Component for managing site information.
 * Handles editing site data, adding images, saving contacts and comments.
 * #site
 * 
 * @param {Object} site Site information
 * @param {Array} devices Array of device objects
 * @param {Array} deviceNonConformities Array of device non-conformity objects
 * @param {Function} setViewInfo Function for setting the view info state
 * @param {Object} registerTemplate Template containing device configurations
 * @param {Function} setLoading Function for setting the loading state
 */
const SiteInfo = ({site, devices, deviceNonConformities, setViewInfo, registerTemplate, setLoading}) => {

    const {sites, setSite, setSites, client} = useStateContext();
    const networkStatus = useNetworkStatus()
    const originalSite = !Array.isArray(sites) ? undefined : sites?.find?.((x)=>x?._id == site?._id)
    //const [contactDetails, setContactDetails] = useState() 

    const siteDoc = {
        ...originalSite,
        image:[],
        images: [],
        comments: [],
        contactDetails: []
    }

    const contactDetails = !Array.isArray(site?.contactDetails) ? [] : site?.contactDetails?.filter?.((x)=>x?.status !== "ARCHIVIATO")?.sort(sortByLastName)

    const {mutate: setDocument} = useSetOnlyPassedData({onError:(e)=>{
        console.log("Document Created Or Updated", e?.message)
        errorAlert("ERRORE, Documento non aggiornato")
        setLoading(false)
    
    }})
    const updatedSites = (updatedDoc) => {
        const siteList = !Array.isArray(sites) ? [] : sites 
        return [...siteList?.filter?.((x)=>x?._id !== updatedDoc?._id), updatedDoc]
    }
    const insertPictureSanity = (data) => {
        //console.log(data)
        const pictures = originalSite?.image ? originalSite?.image : []
        const newPictureDoc = {_id:originalSite?._id, image:[...pictures, data]}
        const queryDoc = {
            documentId: originalSite?._id,
            //doc: newPictureDoc,
            doc: {...originalSite, image:[...pictures, data]}
        }
        setDocument(queryDoc, {
            onSuccess:()=>{
                setSite({...queryDoc?.doc, label: siteName(queryDoc?.doc), value: siteName(queryDoc?.doc)}) 
                setSites(updatedSites(queryDoc?.doc))
            }
        })
    }

    const editComment = (data) => {
        //console.log(data)
        const comments = originalSite?.comments ? originalSite?.comments.filter?.(x=>x?._id !== data?._id) : []
        const newCommentDoc = {_id:originalSite?._id, comments:[...comments, data]}
        const queryDoc = {
            documentId: originalSite?._id,
            //doc:  newCommentDoc,
            doc: {...originalSite, comments:[...comments, data] }
        }
        setDocument(queryDoc, {
            onSuccess:()=>{
                setSite({...queryDoc?.doc, label: siteName(queryDoc?.doc), value: siteName(queryDoc?.doc)})
                setSites(updatedSites(queryDoc?.doc))

            }
        })
        
    }

    const saveContact = (data) => {
        console.log("SAVE CONTACT", data)
        const contacts = !Array.isArray(contactDetails) ? [] : contactDetails?.filter?.(x=>x?._id !== data?._id)
        const contactDoc = {_id:originalSite?._id, contactDetails:[...contacts, data] }
        const queryDoc = {
            //doc:  contactDoc,
            doc:  {...originalSite, contactDetails:[...contacts, data] },
            documentId: originalSite?._id
        }
        setDocument(queryDoc, {
            onSuccess:()=>{
                console.log("CONTACT DATABASE SUCCESS")
                setSite({...queryDoc?.doc, label: siteName(queryDoc?.doc), value: siteName(queryDoc?.doc)})
                setSites(updatedSites(queryDoc?.doc))
            }
        })
    }
    const areCoordinatesPresent = site?.longitude && site?.latitude ? true : false
    const setCoordinates = () => {
        console.log("SET COORDINATES")

        const successCallback = (position) => {
           
            const queryDoc = {
                //doc:  contactDoc,
                doc:  {
                    ...originalSite,
                    latitude: position?.coords?.latitude,
                    longitude: position?.coords?.longitude,
                },
                documentId: originalSite?._id
            }
            console.log("FOUND COORDINATES", {position, queryDoc})
            setDocument(queryDoc, {
            onSuccess:()=>{
                console.log("DATABASE SUCCESS COORDINATES")
                setSite({...queryDoc?.doc, label: siteName(queryDoc?.doc), value: siteName(queryDoc?.doc)})
                setSites(updatedSites(queryDoc?.doc))
                //setLoading(false)
            }
        })

            };      
        const errorCallback = (error) => {
            //setLoading(false)
            errorAlert("ERRORE, impossibile ottenere la posizione, riprovare")
            };
        const options = {
            enableHighAccuracy: true,
            timeout: 10000,
        };
        const geoPosition = () =>  {
            //setLoading(true)
            return navigator.geolocation.getCurrentPosition(
                successCallback,
                errorCallback,
                options
            );}
        Swal.fire({
            text:  areCoordinatesPresent ? "Coordinate già presenti. Aggiornare le coordinate?" : "Inserire le coordinate?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor:  'green',
            cancelButtonColor: 'grey',
            confirmButtonText: areCoordinatesPresent ? "AGGIORNA" : "SALVA",
            cancelButtonText: "ANNULLA"
            }).then((result) => {
                if (result.isConfirmed) {
                    geoPosition()
                }
            })

   
    }

    const clientDetails = {
        devices,
        deviceNonConformities, 
        hideLegenda: true, 
        hideClientsAndSites: true,
        //showToSupply: true,
        registerTemplate,
        client 
    }

  return (
    <div className = "new-device-container">
    <TestButton buttonId='wdkqowdkqwod' message ={"SITE INFO"} consoleData={{site}}/>
    <div style={{display:"flex", flexDirection: "column", justifyContent:"center", alignItems:"center", marginBottom:"15px"}}>
        <h2>{site?.label}</h2>
        <div style={{display:"flex", justifyContent:"center", alignItems:"center", marginBottom:"15px"}}>
            {siteAddress(site)}
            <VisDiv style={{marginLeft:"15px", cursor: "pointer"}} rules={[siteAddress(site), site?.city, site?.address1]}>
                <a href={gMapAddressLink(siteAddress(site))} target='_blank'>
                    <FiMapPin color={"#324d67"} size={30}/>
                </a>
            </VisDiv>
        </div>
        <div>
            <VisDiv style={{display:"flex", alignItems:"center", marginBottom:"15px"}} rules={[areCoordinatesPresent]}>
                <h4>VAI ALLA POSIZIONE:</h4>
               {/*  <p>{site?.longitude}, {site?.latitude}</p> */}
                    <a style={{marginLeft:"5px"}} href={gMapLink(site?.longitude, site?.latitude)} target='_blank'>
                        <FiMapPin color={"#324d67"} size={30}/>
                    </a>
            </VisDiv>
            <VisDiv className={"pdf-button"} onClick={setCoordinates} style={{backgroundColor:"green", display:"flex", alignItems:"center", justifyContent:"center", cursor: "pointer"}}>
                <VisDiv rules={[!site?.longitude || !site?.latitude]}>
                    <p>AGGIUNGI POSIZIONE</p>
                </VisDiv>
                <VisDiv rules={[areCoordinatesPresent]}>
                    <p>MODIFICA POSIZIONE</p>
                </VisDiv>
                <div style={{marginLeft:"5px"}}>
                    <MdGpsFixed size={25} />
                </div>
            </VisDiv>
        </div>
    </div>
        <ClientDetailsReport data = {clientDetails}/>
        <ContactDetails saveFn={saveContact} contactDetails={contactDetails}/>
        <Photos
            destination={originalSite} 
            //saveFn = {insertPicture}
            saveSanityFn={insertPictureSanity}
        />
        <Comments
            destination={originalSite}
            editFn = {editComment}
            hideRead = {true}
        />
        <div style={{display:"flex", justifyContent:"center", alignItems:"center"}}>
            <button onClick={()=>setViewInfo(false)} className='pdf-button'>
                CHIUDI INFORMAZIONI PLESSO
            </button>
        </div>

</div>
  )
}

export default SiteInfo
